<template>
    <div class="mt-4">
        <template v-if="chatMessages && chatMessages.length > 0">
            <chat-message
                v-for="msg in chatMessages"
                :key="msg.id"
                class="my-3"
                :senderName="msg.sender.name"
                :senderAvatar="msg.sender.avatar"
                :senderIsSelf="msg.sender.is_customer === isCustomer"
                :message="
                    isCustomer && !msg.sender.is_customer
                        ? msg.parsed_message
                        : msg.message
                "
                :quote-key="quoteKey"
                :is-customer="isCustomer"
                :disable-pdf-viewer="disablePdfViewer"
                :attachment="msg.attachment"
                :fromAI="Boolean(!msg.sender.is_customer && msg.uses_ai)"
                :timestamp="isCustomer ? null : new Date(msg.created_at)"
            ></chat-message>
        </template>
        <div v-else-if="chatMessages" class="text-center font-italic mb-4">
            Starta en chatt med oss här!
        </div>
        <button
            class="d-block btn signbuttoninline my-2 mx-auto"
            @click="modalOpen = true"
        >
            {{
                chatAvailableForCustomer
                    ? "Skriv meddelande"
                    : "Öppna meddelande"
            }}
        </button>
        <div v-if="unreadCount > 0" class="font-italic text-muted text-center">
            {{ unreadCount }} oläst{{ unreadCount > 1 ? "a" : "" }}
        </div>
        <quote-chat-messages-modal
            :disable-pdf-viewer="disablePdfViewer"
            :quote-key="quoteKey"
            :is-customer="isCustomer"
            :is-template="isTemplate"
            :chat-available-for-customer="chatAvailableForCustomer"
            :chat-attachments-available="chatAttachmentsAvailable"
            :attachment-accept="attachmentAccept"
            :chat-response-time-text="chatResponseTimeText"
            :seller="seller"
            v-model="modalOpen"
        ></quote-chat-messages-modal>
    </div>
</template>

<style scoped></style>

<script setup>
import { route } from "ziggy";
import { onMounted, onUnmounted, ref, watch } from "vue";
import axios from "axios";
import ChatMessage from "./message.vue";
const props = defineProps({
    quoteKey: String,
    disablePdfViewer: Boolean,
    isCustomer: {
        type: Boolean,
        default: false,
    },
    isTemplate: {
        type: Boolean,
        default: false,
    },
    numberToShow: {
        type: Number,
        default: 1,
    },
    chatAvailableForCustomer: {
        type: Boolean,
        default: true,
    },
    chatAttachmentsAvailable: {
        type: Boolean,
        default: false,
    },
    attachmentAccept: {
        type: String,
        default: "",
    },
    chatResponseTimeText: {
        type: String,
        default: "Vår svarstid är 1-2 timmar under vardagar",
    },
    seller: {
        type: String,
    },
});
const chatMessages = ref(undefined);
const unreadCount = ref(0);
const modalOpen = ref(false);
const interval = ref(null);
async function reload() {
    try {
        const response = await axios.get(
            route("quote.chatMessages.index", {
                quoteKey: props.quoteKey,
                is_template: props.isTemplate,
            })
        );
        if (!Array.isArray(response.data.data)) {
            return;
        }
        const loadedChatMessages = response.data.data.sort((a, b) =>
            a.id < b.id ? 1 : -1
        );
        let loadedUnreadCount = 0;
        for (const msg of loadedChatMessages) {
            if (msg.seen) {
                continue;
            }
            if (msg.sender.is_customer === props.isCustomer) {
                continue;
            }
            loadedUnreadCount += 1;
        }
        unreadCount.value = loadedUnreadCount;
        chatMessages.value = loadedChatMessages
            .slice(0, props.numberToShow)
            .reverse();
    } catch (error) {
        console.log(error);
    }
}
watch(modalOpen, async (newValue, oldValue) => {
    if (!newValue) {
        await reload();
    }
});
onMounted(async () => {
    await reload();
    interval.value = setInterval(async () => {
        await reload();
    }, 20000);
    window.addEventListener("ChatModalOpen", (event) => {
        if (event.detail?.quoteKey) {
            return;
        }
        event.preventDefault();
        modalOpen.value = true;
    });
});
onUnmounted(() => {
    clearInterval(interval.value);
    interval.value = null;
});
</script>
